import React from "react";
import GlobalDialog from "../mui/Dialogue/GlobalDialog";
import { AddButton, CancelButton, SaveButton } from "../mui/Buttons/Buttons";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
    addCategories,
    getClassPreData,
    getPackageSubjectSessions,
    getProjectCategories,
    getProjectPackagesPreData,
    getProjectsPreData,
    getSubjectsPreData,
} from "../../redux/features/mastersSlice";
import { useSnackbar } from "notistack";

export const AddPackageSubjectSession = () => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const data = useSelector((state) => state.masters);

    const Schema = Yup.object().shape({
        packageId: Yup.string().required("package is required"),
        subjectId: Yup.string().required("subject is required"),
        packageSubjectSessions: Yup.string().required(
            "packageSubjectSessions is required"
        ),
        baseCourseId: Yup.string().required("baseCourse is required"),
    });

    const formik = useFormik({
        initialValues: {
            packageId: "",
            subjectId: "",
            packageSubjectSessions: "",
            baseCourseId: "",
        },
        validationSchema: Schema,
        onSubmit: (values, { resetForm }) => {
            console.log(values);
            dispatch(addCategories(values)).then((res) => {
                if (res.payload.status === "failed") {
                    enqueueSnackbar(res.payload.message, { variant: "error" });
                } else if (res.payload.status === "success") {
                    setOpen(false);
                    resetForm();
                    dispatch(getPackageSubjectSessions());
                    enqueueSnackbar(res.payload.message, {
                        variant: "success",
                    });
                }
            });
        },
    });
    return (
        <div>
            <GlobalDialog
                title="Add Package Subject Session"
                open={open}
                setOpen={setOpen}
                fullWidth
                maxWidth={"sm"}
                popupButton={
                    <AddButton
                        action={() => {
                            dispatch(getProjectPackagesPreData());
                            dispatch(getSubjectsPreData());
                            setOpen(true);
                        }}
                    >
                        Add Package Subject Session
                    </AddButton>
                }
                content={
                    <>
                        <FormikProvider value={formik}>
                            <Form onSubmit={formik.handleSubmit}>
                                <Box>
                                    <Stack direction={"column"} spacing={2}>
                                        <Autocomplete
                                            disablePortal
                                            name="packageId"
                                            id="combo-box-demo"
                                            options={
                                                data.projectPackagesPreData
                                            }
                                            getOptionLabel={(option) =>
                                                option.name
                                            }
                                            onChange={(e, option) => {
                                                formik.setFieldValue(
                                                    "packageId",
                                                    option.id
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    disabled
                                                    fullWidth
                                                    {...params}
                                                    label="Package"
                                                    error={
                                                        formik.touched
                                                            .packageId &&
                                                        Boolean(
                                                            formik.errors
                                                                .packageId
                                                        )
                                                    }
                                                    helperText={
                                                        formik.errors.packageId
                                                    }
                                                />
                                            )}
                                        />

                                        <Autocomplete
                                            disablePortal
                                            name="subjectId"
                                            id="combo-box-demo"
                                            options={data.subjectsPreData}
                                            getOptionLabel={(option) =>
                                                option.name
                                            }
                                            onChange={(e, option) => {
                                                formik.setFieldValue(
                                                    "subjectId",
                                                    option.id
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    disabled
                                                    fullWidth
                                                    {...params}
                                                    label="subject"
                                                    error={
                                                        formik.touched
                                                            .subjectId &&
                                                        Boolean(
                                                            formik.errors
                                                                .subjectId
                                                        )
                                                    }
                                                    helperText={
                                                        formik.errors.subjectId
                                                    }
                                                />
                                            )}
                                        />
                                        <TextField
                                            label="Category Name"
                                            fullWidth
                                            name="categoryName"
                                            value={formik.values.categoryName}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.categoryName &&
                                                Boolean(
                                                    formik.errors.categoryName
                                                )
                                            }
                                            helperText={
                                                formik.errors.categoryName
                                            }
                                        />

                                        <TextField
                                            label="Category Description"
                                            fullWidth
                                            name="categoryDescription"
                                            value={
                                                formik.values
                                                    .categoryDescription
                                            }
                                            multiline
                                            rows={3}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched
                                                    .categoryDescription &&
                                                Boolean(
                                                    formik.errors
                                                        .categoryDescription
                                                )
                                            }
                                            helperText={
                                                formik.errors
                                                    .categoryDescription
                                            }
                                        />
                                    </Stack>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 2,
                                        }}
                                    >
                                        <Stack spacing={2} direction={"row"}>
                                            <CancelButton
                                                action={() => setOpen(false)}
                                            >
                                                Cancel
                                            </CancelButton>
                                            <SaveButton type="submit">
                                                {data.loading
                                                    ? "Saving..."
                                                    : "Save"}
                                            </SaveButton>
                                        </Stack>
                                    </Box>
                                </Box>
                            </Form>
                        </FormikProvider>
                    </>
                }
            />
        </div>
    );
};
